import firebaseServices from "./firebase/init"
import auth from "./firebase/auth"
import db from "./firebase/db"

const service = {
  firebaseServices,
  auth,
  db,
}
export default service
